import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import CartStep from '../CartStep';
import Seats from '../Seats';
import PaymentInfo from '../payment/PaymentInfo';
import ContactDetails from '../ContactDetails';
import Order from '../order/Order';
import GroupedTickets from '../GroupedTickets';
import useLoadingCartStep from '../../hoc/useLoadingCartStep';
import groupedTickets from '../../utils/helpers';
import { buyTickets, saveContactDetails } from '../../actions';
import { selectCartFormData, selectCartSeats, selectCartTickets } from '../../selectors';
import { localeSelector } from '../../../core/selectors/i18n';
import { setFormFieldValid, setFormFieldValue, setFieldErrorMessage } from '../../actions/forms';
import { CART_STEP_4 } from '../../constants/steps';
import { CONTACT_DETAILS_FORM_NAME } from '../../reducers/features/contact-details';
import { BUY_FORM, BUY_FORM_TERMS_FIELD } from '../../reducers/features/buy';

const CartStep2 = () => useLoadingCartStep(CartStep2Content);
const CartStep2Content = ({ currency }) => {
    const dispatch = useDispatch();

    const title = <FormattedMessage id="all_details_corect" />;
    const locale = useSelector(localeSelector);
    const tickets = groupedTickets(useSelector(selectCartTickets));
    const seats = useSelector(selectCartSeats);
    const buyInputs = useSelector((state) => selectCartFormData(state, BUY_FORM));
    const inputs = useSelector((state) => selectCartFormData(state, CONTACT_DETAILS_FORM_NAME));

    const onCheckboxChange = (checked) => {
        dispatch(setFormFieldValue(BUY_FORM, BUY_FORM_TERMS_FIELD, checked));
    };

    const submitPayment = () => {
        if (!buyInputs[BUY_FORM_TERMS_FIELD].value) {
            dispatch(setFormFieldValid(BUY_FORM, BUY_FORM_TERMS_FIELD, false));
            dispatch(setFieldErrorMessage(BUY_FORM, BUY_FORM_TERMS_FIELD, <FormattedMessage id="accept_terms_error" />));
            const checkbox = document.getElementById('terms');
            if (checkbox) {
                checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            return;
        }

        dispatch(saveContactDetails(inputs, () => dispatch(buyTickets())));
    };

    return (
        <CartStep title={title}>
            <div className={`cart__content cart__content--${CART_STEP_4}`}>
                <div className="row">
                    <div className="col-lg-6 col-12 mb-4">
                        <Order open>
                            <GroupedTickets tickets={tickets} currency={currency} />
                        </Order>
                        <div className="mb-4"/>
                        <Seats userSeats={seats} open />
                    </div>
                    <div className="col-lg-6 col-12 mb-4">
                        <ContactDetails />
                        <div className="mb-4" />
                        <PaymentInfo
                            tickets={tickets} onSubmitPayment={submitPayment} buyInputs={buyInputs} locale={locale}
                            onCheckboxChange={onCheckboxChange}
                        />
                    </div>
                </div>
            </div>
        </CartStep>
    );
};

export default CartStep2;
